import {createSvgIcon} from '../create-svg-icon';

export const KeyboardDoubleArrowRightIcon = createSvgIcon(
  [<path d="M6.41 6 5 7.41 9.58 12 5 16.59 6.41 18l6-6z" key="0" />,<path d="m13 6-1.41 1.41L16.17 12l-4.58 4.59L13 18l6-6z" key="1" />,]
, 'KeyboardDoubleArrowRightOutlined');
